import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";
import ClientReferral from "./index";
import { Handshake } from "lucide-react";
import { MODULE_CLIENT_REFERRAL } from "variables/modules";

const clientReferralRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Client Referral",
		basePath: "client-referrals",
		mainComponent: <ClientReferral />,
	    layout: "/console",	   
	    icon: <Handshake className="icon-item" />,
	    subTitle:"Client Referral",
		level:3,
		moduleId: MODULE_CLIENT_REFERRAL,
	})
]

export default clientReferralRoutes;